export const sofiaBoyanaTranslations = {
  en: {
    breadcrumb: { home: 'Home', locations: 'Locations', boyana: 'Sofia, Boyana' },
    hero: {
      badge: 'Sofia, Boyana',
      heading: 'Home of Football - National Football Base Boyana',
      subheading: 'Premier Football Training Facility',
      football: 'Football',
      district: 'Sofia, Boyana district',
      grandstand: 'Grandstand for 348 people',
      threeFields: '3 football fields',
      onsiteAccommodation: 'On-site accommodation',
      bookFacility: 'Book This Facility',
    },
    overview: {
      heading: 'Facility Overview',
      cards: [
        { heading: 'Facility Type', content: 'National Football Base', subtext: 'Home of Football' },
        { heading: 'Grandstand Capacity', content: '348 People', subtext: 'Overlooking main pitch' },
        { heading: 'Football Fields', content: '3 Professional Pitches', subtext: '2 natural grass, 1 artificial' },
        { heading: 'Accommodation', content: 'On-Site Available', subtext: 'Team rooms and dining facilities' },
      ],
    },
    about: {
      heading: 'About National Football Base Boyana',
      description: 'Home of Football - National Football Base Boyana is a comprehensive sports facility equipped with a wide range of amenities to accommodate various sports and physical activities. The sports base nestles in the skirts of Vitosha, includes three football fields (two with natural and one with artificial grass), a grandstand for 348 people overlooks the main pitch, two tennis courts, parking and alleys.',
      keyHighlights: 'Key Highlights',
      highlights: [
        'Three professional football fields (2 natural grass, 1 artificial grass)',
        'Grandstand for 348 people overlooking the main pitch',
        'Two tennis courts for additional training options',
        'Located in the skirts of Vitosha Mountain',
        'On-site accommodation with team rooms',
        'Dining facilities and cafeteria services',
        'Conference and meeting rooms for tactical sessions',
        'Modern locker rooms and changing facilities',
        'Parking facilities and alleys',
        'Ideal for football training camps and tournaments',
      ],
      testimonial: '"The Home of Football - National Football Base Boyana, nestled in the skirts of Vitosha, offers world-class football facilities with three professional pitches and a grandstand for 348 spectators."',
      testimonialAttribution: 'Champion Maker Team',
    },
    sports: {
      heading: 'Football Training Facilities',
      professionalPitches: 'Professional Football Pitches',
      pitchesDesc: 'Three professional football fields including two with natural grass and one with artificial grass. The main pitch features a grandstand for 348 people, perfect for training sessions, matches, and tournaments.',
      viewSpecs: 'View Specifications',
      hideSpecs: 'Hide Specifications',
      pitchFacilities: 'Pitch Facilities:',
      pitchFacilitiesList: ['Two natural grass football pitches', 'One artificial grass football pitch', 'Grandstand for 348 people overlooking main pitch', 'Professional goal posts and nets', 'Floodlighting for evening training', 'Well-maintained playing surfaces'],
      idealFor: 'Ideal For:',
      pitchesIdealFor: ['Professional team training camps', 'Tactical training sessions', 'Match preparation and competitions', 'Multiple team training simultaneously', 'Football tournaments with spectator viewing', 'Youth academy training programs'],
      strengthConditioning: 'Strength & Conditioning',
      strengthDesc: 'Professional gym facilities specifically designed for football players, featuring comprehensive strength and conditioning equipment for optimal athletic performance.',
      gymFacilities: 'Gym Facilities:',
      gymFacilitiesList: ['Professional strength training equipment', 'Football-specific conditioning tools', 'Cardio training machines', 'Functional training areas', 'Recovery and rehabilitation equipment', 'Professional fitness assessment tools'],
      gymIdealFor: ['Football-specific strength training', 'Injury prevention programs', 'Performance enhancement', 'Recovery and rehabilitation', 'Pre-season conditioning', 'Year-round fitness maintenance'],
    },
    amenities: {
      heading: 'World-Class Facilities & Amenities',
      items: [
        { title: 'Grandstand', desc: 'Grandstand for 348 people overlooking the main pitch' },
        { title: 'Three Football Fields', desc: 'Two natural grass and one artificial grass football pitches' },
        { title: 'Tennis Courts', desc: 'Two tennis courts for additional training options' },
        { title: 'Modern Locker Rooms', desc: 'Spacious changing facilities with showers, lockers, and benches' },
        { title: 'Equipment Storage', desc: 'Secure storage areas for sports equipment and personal belongings' },
        { title: 'On-Site Accommodation', desc: 'Team rooms and accommodation facilities available on-site' },
        { title: 'Parking Available', desc: 'Convenient parking facilities and alleys for teams and visitors' },
        { title: 'Equipment Rental', desc: 'Sports equipment available for rent for all activities' },
        { title: 'WiFi Available', desc: 'High-speed wireless internet throughout the facility' },
        { title: 'Cafeteria Services', desc: 'On-site dining facilities providing meals and refreshments' },
        { title: 'Medical Facilities', desc: 'First aid and medical assistance available' },
        { title: 'Conference Rooms', desc: 'Meeting and conference rooms for team activities' },
        { title: 'Gym Facilities', desc: 'Professional gym with strength & conditioning equipment' },
        { title: 'Professional Lighting', desc: 'LED lighting systems for indoor and outdoor areas' },
        { title: 'Dining Facilities', desc: 'Full meal service available for training camps' },
      ],
    },
    gallery: {
      heading: 'Facility Gallery',
      subheading: 'Explore our world-class football training environment',
    },
    galleryImages: { heading: 'Facility Gallery Images' },
    access: {
      heading: 'Location & How to Get Here',
      address: 'Address',
      addressLine1: 'National Football Base Boyana',
      addressLine2: 'Boyana District',
      addressLine3: 'Sofia, Bulgaria',
      getDirections: 'Get Directions',
      byCar: 'By Car',
      car1: 'Parking available on-site',
      car2: 'Easy access from main roads',
      car3: 'Approximately 12 minutes from Sofia city center',
      byBus: 'By Public Transport',
      bus1: 'Bus lines available to Boyana',
      bus2: 'Well-connected public transport',
      bus3: 'Short walk from bus stops',
      fromAirport: 'From Airport',
      airport1: 'Distance: Approximately 8 km from Sofia Airport',
      airport2: 'Transfer time: 15-20 minutes by car',
      airport3: 'We provide airport transfer services',
      nearbyLandmarks: 'Nearby Landmarks',
      nearby1: 'Nestled in the skirts of Vitosha Mountain',
      nearby2: 'Boyana Church - 5 min drive',
      nearby3: 'Vitosha Mountain - Direct access',
    },
    pricing: {
      heading: 'Pricing & Availability',
      flexiblePricing: 'Flexible Pricing Options',
      pricingVaries: 'Pricing varies based on:',
      factors: [
        'Duration of booking (hourly, half-day, full-day, multi-day)',
        'Season and demand',
        'Number of pitches needed',
        'Accommodation requirements (on-site available)',
        'Additional services required',
        'Football equipment rental needs',
        'Support staff requirements',
      ],
      pricingNote: 'For detailed pricing and package options, please contact us with your specific requirements. On-site accommodation packages available.',
      whatsIncluded: "What's Included:",
      included: [
        'Football pitch access for specified time',
        'Basic football equipment (balls, cones, goals)',
        'Locker room facilities',
        'Gym facility access',
        'Conference room access for tactical sessions',
        'On-site staff support',
      ],
      optionalAddons: 'Optional Add-ons:',
      addons: [
        'On-site accommodation (team rooms)',
        'Full meal plans (breakfast, lunch, dinner)',
        'Football equipment rental (additional gear)',
        'Extended training hours',
        'Professional football coaching services',
        'Medical support and physiotherapy',
        'Video analysis and tactical support',
      ],
      requestQuote: 'Request a Quote',
    },
    testimonials: {
      heading: 'What Teams Say About Training Here',
      items: [
        { quote: "National Football Base Boyana provided exceptional football training facilities for our team. The quality of the three pitches (two natural and one artificial grass) and the grandstand exceeded our expectations. The on-site accommodation made our training camp seamless and professional!", name: "Coach Peter Stoyanov", date: "September 2025" },
        { quote: "Perfect football training venue with excellent pitches and facilities. The combination of outdoor fields, gym facilities, and on-site accommodation made it ideal for our international team. Highly recommend for serious football training!", name: "Coach Maria Rodriguez", date: "August 2025" },
        { quote: "Outstanding football training facility. The pitches are well-maintained and the gym facilities are top-notch for strength and conditioning. The conference rooms were perfect for team meetings and tactical sessions.", name: "Coach John Anderson", date: "July 2025" },
        { quote: "Excellent football facility with great amenities. The on-site accommodation and dining facilities made our training camp seamless. Our players loved the professional setup and quality of the training pitches.", name: "Coach Klaus Mueller", date: "June 2025" },
      ],
    },
    similar: {
      heading: 'Explore Other Locations in Sofia',
      viewDetails: 'View Details',
      locations: [
        { name: 'Sofia, Mladost', location: 'Sofia, Mladost', badge: 'Basketball & Volleyball', description: 'Modern basketball and volleyball training facility', path: '/locations/sofia-mladost' },
        { name: 'National Sports Academy', location: 'Sofia, NSA', badge: 'Athletics', description: 'World-class athletics and track & field facilities', path: '/locations/sofia-nsa' },
        { name: 'Plovdiv Aquatic Center', location: 'Plovdiv', badge: 'Swimming', description: 'Olympic-size swimming pool and aquatic center', path: '/locations/plovdiv' },
      ],
    },
    faq: {
      heading: 'Frequently Asked Questions',
      items: [
        { question: 'What football training facilities are available?', answer: 'The facility features professional outdoor football pitches with high-quality grass surfaces, perfect for team training, tactical sessions, and match preparation. We also have gym facilities for strength and conditioning.' },
        { question: 'Is on-site accommodation available?', answer: 'Yes! This is one of our locations that offers on-site accommodation, making it perfect for extended football training camps. Team rooms and dining facilities are available.' },
        { question: 'Can multiple teams train simultaneously?', answer: 'Absolutely! The facility is designed to accommodate multiple football teams training simultaneously on different pitches, making it ideal for large training camps and tournaments.' },
        { question: 'What are the facility operating hours?', answer: 'The facility operates from 6:00 AM to 11:00 PM daily. Extended hours can be arranged for training camps and special events upon request.' },
        { question: 'Are conference rooms available for team meetings?', answer: 'Yes, the facility includes conference and meeting rooms perfect for team meetings, tactical analysis sessions, and presentations.' },
        { question: 'How far is it from Sofia Airport?', answer: 'Sofia, Boyana is approximately 8 km from Sofia Airport, about 15-20 minutes by car. We provide airport transfer services.' },
        { question: 'Can we host football tournaments here?', answer: 'Yes! The facility is equipped for hosting football tournaments and competitions with multiple pitches available simultaneously.' },
        { question: 'What dining options are available?', answer: 'The facility has a cafeteria providing meals and refreshments. Full meal plans can be arranged as part of your training camp package.' },
        { question: 'Is the facility accessible for people with disabilities?', answer: 'Yes, the facility is wheelchair accessible with appropriate facilities for athletes and visitors with disabilities.' },
        { question: 'What is the quality of the football pitches?', answer: 'Our football pitches feature professional-grade grass surfaces that are well-maintained and suitable for high-level training and matches. The pitches are regularly maintained to ensure optimal playing conditions.' },
      ],
    },
    cta: {
      heading: 'Ready to Book National Football Base Boyana?',
      subheading: 'Contact us to reserve your training dates',
      sendInquiry: 'Send a quick inquiry',
      requestInfo: 'Request Information',
      speakWithTeam: 'Speak with our team',
      getCompletePackage: 'Get a complete package',
      bookCompletePackage: 'Book Complete Package',
      ctaCallNow: 'Call Now',
    },
  },
  ar: {
    breadcrumb: { home: 'الرئيسية', locations: 'المواقع', boyana: 'صوفيا، بويانا' },
    hero: {
      badge: 'صوفيا، بويانا',
      heading: 'موطن كرة القدم - القاعدة الوطنية لكرة القدم بويانا',
      subheading: 'منشأة تدريب كرة قدم رائدة',
      football: 'كرة القدم',
      district: 'صوفيا، حي بويانا',
      grandstand: 'مدرج لـ 348 شخصاً',
      threeFields: '3 ملاعب كرة قدم',
      onsiteAccommodation: 'إقامة في الموقع',
      bookFacility: 'احجز هذه المنشأة',
    },
    overview: {
      heading: 'نظرة عامة على المنشأة',
      cards: [
        { heading: 'نوع المنشأة', content: 'القاعدة الوطنية لكرة القدم', subtext: 'موطن كرة القدم' },
        { heading: 'سعة المدرج', content: '348 شخصاً', subtext: 'يطل على الملعب الرئيسي' },
        { heading: 'ملاعب كرة القدم', content: '3 ملاعب احترافية', subtext: 'عشب طبيعي 2، صناعي 1' },
        { heading: 'الإقامة', content: 'متاحة في الموقع', subtext: 'غرف فرق ومرافق طعام' },
      ],
    },
    about: {
      heading: 'عن القاعدة الوطنية لكرة القدم بويانا',
      description: 'موطن كرة القدم - القاعدة الوطنية لكرة القدم في بويانا منشأة رياضية شاملة مجهزة بمجموعة واسعة من المرافق لاستيعاب مختلف الرياضات والأنشطة البدنية. تقع القاعدة في أحضان فيتوشا، وتضم ثلاثة ملاعب كرة قدم (اثنان بعشب طبيعي وواحد صناعي)، مدرج لـ 348 شخصاً يطل على الملعب الرئيسي، ملعبي تنس، موقف سيارات وممرات.',
      keyHighlights: 'أبرز المميزات',
      highlights: [
        'ثلاثة ملاعب كرة قدم احترافية (عشب طبيعي 2، صناعي 1)',
        'مدرج لـ 348 شخصاً يطل على الملعب الرئيسي',
        'ملعبي تنس لخيارات تدريب إضافية',
        'تقع في أحضان جبل فيتوشا',
        'إقامة في الموقع مع غرف فرق',
        'مرافق طعام وخدمات كافيتريا',
        'قاعات مؤتمرات واجتماعات للجلسات التكتيكية',
        'غرف خلع ملابس ومرافق تغيير حديثة',
        'مرافق انتظار سيارات وممرات',
        'مثالي لمعسكرات ومسابقات تدريب كرة القدم',
      ],
      testimonial: '"موطن كرة القدم - القاعدة الوطنية لكرة القدم بويانا، في أحضان فيتوشا، توفر مرافق كرة قدم عالمية المستوى مع ثلاثة ملاعب احترافية ومدرج لـ 348 متفرجاً."',
      testimonialAttribution: 'فريق صناع الأبطال',
    },
    sports: {
      heading: 'مرافق تدريب كرة القدم',
      professionalPitches: 'ملاعب كرة قدم احترافية',
      pitchesDesc: 'ثلاثة ملاعب كرة قدم احترافية منها اثنان بعشب طبيعي وواحد صناعي. يتميز الملعب الرئيسي بمدرج لـ 348 شخصاً، مثالي لجلسات التدريب والمواجهات والبطولات.',
      viewSpecs: 'عرض المواصفات',
      hideSpecs: 'إخفاء المواصفات',
      pitchFacilities: 'مرافق الملاعب:',
      pitchFacilitiesList: ['ملعبي كرة قدم بعشب طبيعي', 'ملعب كرة قدم بعشب صناعي', 'مدرج لـ 348 شخصاً يطل على الملعب الرئيسي', 'قوائم مرمى وشباك احترافية', 'إضاءة للتدريب المسائي', 'أسطح لعب صيانتها جيدة'],
      idealFor: 'مثالي لـ:',
      pitchesIdealFor: ['معسكرات تدريب فرق احترافية', 'جلسات تدريب تكتيكية', 'التحضير للمواجهات والمسابقات', 'تدريب فرق متعددة في وقت واحد', 'بطولات كرة قدم مع مشاهدة المتفرجين', 'برامج تدريب أكاديميات الشباب'],
      strengthConditioning: 'القوة والتكييف',
      strengthDesc: 'مرافق صالة رياضية احترافية مصممة خصيصاً لاعبي كرة القدم، مع معدات شاملة للقوة والتكييف لأداء رياضي مثالي.',
      gymFacilities: 'مرافق الصالة الرياضية:',
      gymFacilitiesList: ['معدات تدريب قوة احترافية', 'أدوات تكييف خاصة بكرة القدم', 'آلات تمارين هوائية', 'مناطق تدريب وظيفية', 'معدات تعافي وإعادة تأهيل', 'أدوات تقييم لياقة احترافية'],
      gymIdealFor: ['تدريب قوة خاص بكرة القدم', 'برامج الوقاية من الإصابات', 'تحسين الأداء', 'التعافي وإعادة التأهيل', 'التكييف ما قبل الموسم', 'الحفاظ على اللياقة على مدار العام'],
    },
    amenities: {
      heading: 'مرافق وخدمات عالمية المستوى',
      items: [
        { title: 'المدرج', desc: 'مدرج لـ 348 شخصاً يطل على الملعب الرئيسي' },
        { title: 'ثلاثة ملاعب كرة قدم', desc: 'ملعبان بعشب طبيعي وملعب بعشب صناعي' },
        { title: 'ملعبي تنس', desc: 'ملعبي تنس لخيارات تدريب إضافية' },
        { title: 'غرف خلع ملابس حديثة', desc: 'مرافق تغيير واسعة مع دوش وخزائن ومقاعد' },
        { title: 'تخزين المعدات', desc: 'مناطق تخزين آمنة للمعدات الرياضية والممتلكات الشخصية' },
        { title: 'إقامة في الموقع', desc: 'غرف فرق ومرافق إقامة متاحة في الموقع' },
        { title: 'موقف سيارات متاح', desc: 'مرافق انتظار وممرات مريحة للفرق والزوار' },
        { title: 'تأجير المعدات', desc: 'معدات رياضية متاحة للتأجير لجميع الأنشطة' },
        { title: 'واي فاي متاح', desc: 'إنترنت لاسلكي عالي السرعة في جميع أنحاء المنشأة' },
        { title: 'خدمات كافيتريا', desc: 'مرافق طعام في الموقع توفر وجبات ومرطبات' },
        { title: 'مرافق طبية', desc: 'إسعافات أولية ومساعدة طبية متاحة' },
        { title: 'قاعات مؤتمرات', desc: 'قاعات اجتماعات ومؤتمرات لأنشطة الفرق' },
        { title: 'مرافق صالة رياضية', desc: 'صالة رياضية احترافية مع معدات القوة والتكييف' },
        { title: 'إضاءة احترافية', desc: 'أنظمة إضاءة LED للمناطق الداخلية والخارجية' },
        { title: 'مرافق طعام', desc: 'خدمة وجبات كاملة متاحة لمعسكرات التدريب' },
      ],
    },
    gallery: {
      heading: 'معرض المنشأة',
      subheading: 'استكشف بيئة تدريب كرة القدم عالمية المستوى',
    },
    galleryImages: { heading: 'صور معرض المنشأة' },
    access: {
      heading: 'الموقع وكيفية الوصول',
      address: 'العنوان',
      addressLine1: 'القاعدة الوطنية لكرة القدم بويانا',
      addressLine2: 'حي بويانا',
      addressLine3: 'صوفيا، بلغاريا',
      getDirections: 'الحصول على الاتجاهات',
      byCar: 'بالسيارة',
      car1: 'موقف سيارات متاح في الموقع',
      car2: 'وصول سهل من الطرق الرئيسية',
      car3: 'حوالي 12 دقيقة من وسط صوفيا',
      byBus: 'بالنقل العام',
      bus1: 'خطوط حافلات متاحة إلى بويانا',
      bus2: 'نقل عام مترابط',
      bus3: 'مسافة قصيرة سيراً من محطات الحافلات',
      fromAirport: 'من المطار',
      airport1: 'المسافة: حوالي 8 كم من مطار صوفيا',
      airport2: 'وقت النقل: 15-20 دقيقة بالسيارة',
      airport3: 'نوفر خدمات نقل من المطار',
      nearbyLandmarks: 'معالم قريبة',
      nearby1: 'في أحضان جبل فيتوشا',
      nearby2: 'كنيسة بويانا - 5 دقائق بالسيارة',
      nearby3: 'جبل فيتوشا - وصول مباشر',
    },
    pricing: {
      heading: 'الأسعار والتوفر',
      flexiblePricing: 'خيارات أسعار مرنة',
      pricingVaries: 'تختلف الأسعار حسب:',
      factors: [
        'مدة الحجز (بالساعة، نصف يوم، يوم كامل، أيام متعددة)',
        'الموسم والطلب',
        'عدد الملاعب المطلوبة',
        'متطلبات الإقامة (متاحة في الموقع)',
        'الخدمات الإضافية المطلوبة',
        'احتياجات تأجير معدات كرة القدم',
        'متطلبات طاقم الدعم',
      ],
      pricingNote: 'للحصول على تفاصيل الأسعار وخيارات الباقات، يرجى الاتصال بنا مع متطلباتك المحددة. باقات إقامة في الموقع متاحة.',
      whatsIncluded: 'ما الذي يُدرج:',
      included: [
        'وصول لملعب كرة القدم للوقت المحدد',
        'معدات كرة قدم أساسية (كرات، مخروطات، مرامي)',
        'مرافق غرف خلع الملابس',
        'وصول الصالة الرياضية',
        'وصول قاعة المؤتمرات للجلسات التكتيكية',
        'دعم الطاقم في الموقع',
      ],
      optionalAddons: 'إضافات اختيارية:',
      addons: [
        'إقامة في الموقع (غرف فرق)',
        'خطط وجبات كاملة (فطور، غداء، عشاء)',
        'تأجير معدات كرة القدم (معدات إضافية)',
        'ساعات تدريب إضافية',
        'خدمات تدريب كرة قدم احترافية',
        'دعم طبي وعلاج فيزيائي',
        'تحليل فيديو ودعم تكتيكي',
      ],
      requestQuote: 'طلب عرض أسعار',
    },
    testimonials: {
      heading: 'ماذا تقول الفرق عن التدريب هنا',
      items: [
        { quote: 'وفرت القاعدة الوطنية لكرة القدم بويانا مرافق تدريب استثنائية لفريقنا. تجاوزت جودة الملاعب الثلاثة (عشب طبيعي اثنان وصناعي واحد) والمدرج توقعاتنا. جعلت الإقامة في الموقع معسكر التدريب سلساً واحترافياً!', name: 'المدرب بيتر ستويانوف', date: 'سبتمبر 2025' },
        { quote: 'مكان تدريب كرة قدم مثالي بملاعب ومرافق ممتازة. الجمع بين الملاعب الخارجية ومرافق الصالة الرياضية والإقامة في الموقع جعله مثالياً لفريقنا الدولي. أوصي بشدة للتدريب الجاد على كرة القدم!', name: 'المدرب ماريا رودريغيز', date: 'أغسطس 2025' },
        { quote: 'منشأة تدريب كرة قدم متميزة. الملاعب صيانتها جيدة ومرافق الصالة الرياضية من الطراز الأول للقوة والتكييف. كانت قاعات المؤتمرات مثالية لاجتماعات الفريق والجلسات التكتيكية.', name: 'المدرب جون أندرسون', date: 'يوليو 2025' },
        { quote: 'منشأة كرة قدم ممتازة بمرافق رائعة. جعلت الإقامة في الموقع ومرافق الطعام معسكر التدريب سلساً. أحب لاعباتنا الإعداد الاحترافي وجودة ملاعب التدريب.', name: 'المدرب كلاوس مولر', date: 'يونيو 2025' },
      ],
    },
    similar: {
      heading: 'استكشف مواقع أخرى في صوفيا',
      viewDetails: 'عرض التفاصيل',
      locations: [
        { name: 'صوفيا، ملادوست', location: 'صوفيا، ملادوست', badge: 'كرة السلة والطائرة', description: 'منشأة تدريب حديثة لكرة السلة والطائرة', path: '/locations/sofia-mladost' },
        { name: 'الأكاديمية الوطنية للرياضة', location: 'صوفيا، الأكاديمية الوطنية', badge: 'ألعاب القوى', description: 'مرافق ألعاب قوى وجري وميدان عالمية المستوى', path: '/locations/sofia-nsa' },
        { name: 'مركز بلوفديف المائي', location: 'بلوفديف', badge: 'السباحة', description: 'مسبح أولمبي ومركز مائي', path: '/locations/plovdiv' },
      ],
    },
    faq: {
      heading: 'الأسئلة الشائعة',
      items: [
        { question: 'ما مرافق تدريب كرة القدم المتاحة؟', answer: 'تضم المنشأة ملاعب كرة قدم خارجية احترافية بأسطح عشب عالية الجودة، مثالية لتدريب الفرق والجلسات التكتيكية والتحضير للمواجهات. لدينا أيضاً مرافق صالة رياضية للقوة والتكييف.' },
        { question: 'هل تتوفر إقامة في الموقع؟', answer: 'نعم! هذه إحدى مواقعنا التي توفر إقامة في الموقع، ما يجعلها مثالية لمعسكرات تدريب كرة القدم الممتدة. غرف فرق ومرافق طعام متاحة.' },
        { question: 'هل يمكن لفرق متعددة التدريب في وقت واحد؟', answer: 'بالتأكيد! صُممت المنشأة لاستيعاب فرق كرة قدم متعددة تتدرب في وقت واحد على ملاعب مختلفة، ما يجعلها مثالية للمعسكرات والبطولات الكبيرة.' },
        { question: 'ما ساعات عمل المنشأة؟', answer: 'تعمل المنشأة من 6:00 صباحاً إلى 11:00 مساءً يومياً. يمكن ترتيب ساعات إضافية لمعسكرات التدريب والفعاليات الخاصة عند الطلب.' },
        { question: 'هل تتوفر قاعات مؤتمرات لاجتماعات الفريق؟', answer: 'نعم، تضم المنشأة قاعات مؤتمرات واجتماعات مثالية لاجتماعات الفريق وجلسات التحليل التكتيكي والعروض التقديمية.' },
        { question: 'كم تبعد عن مطار صوفيا؟', answer: 'صوفيا، بويانا على بعد حوالي 8 كم من مطار صوفيا، نحو 15-20 دقيقة بالسيارة. نوفر خدمات نقل من المطار.' },
        { question: 'هل يمكننا تنظيم بطولات كرة قدم هنا؟', answer: 'نعم! المنشأة مجهزة لاستضافة بطولات ومسابقات كرة القدم مع ملاعب متعددة متاحة في وقت واحد.' },
        { question: 'ما خيارات الطعام المتاحة؟', answer: 'المنشأة لديها كافيتريا توفر وجبات ومرطبات. يمكن ترتيب خطط وجبات كاملة كجزء من باقة معسكر التدريب.' },
        { question: 'هل المنشأة متاحة لذوي الاحتياجات الخاصة؟', answer: 'نعم، المنشأة متاحة للكراسي المتحركة مع مرافق مناسبة للرياضيين والزوار ذوي الاحتياجات الخاصة.' },
        { question: 'ما جودة ملاعب كرة القدم؟', answer: 'ملاعب كرة القدم لدينا تتميز بأسطح عشب احترافية الجودة وصيانتها جيدة ومناسبة للتدريب والمواجهات عالية المستوى. تُصان الملاعب بانتظام لضمان ظروف لعب مثالية.' },
      ],
    },
    cta: {
      heading: 'مستعد لحجز القاعدة الوطنية لكرة القدم بويانا؟',
      subheading: 'اتصل بنا لحجز مواعيد التدريب',
      sendInquiry: 'أرسل استفساراً سريعاً',
      requestInfo: 'طلب معلومات',
      speakWithTeam: 'تحدث مع فريقنا',
      getCompletePackage: 'احصل على باقة كاملة',
      bookCompletePackage: 'احجز الباقة الكاملة',
      ctaCallNow: 'اتصل الآن',
    },
  },
};
